<app-header></app-header>
<p-toast></p-toast>
<div class="home-main">
  <div class="sidebar">
    <app-sidebar
      (headingEvent)="receiveHeading($event)"
      (toggleSidebarEvent)="receiveSidebarEvent($event)"
    />
  </div>
  <div
    class="main-container"
    [ngClass]="toggle_sidebar ? 'main_content_2' : 'main_content_1'"
  >
  <nav class="breadcrumb">
    <a (click)="goBackToSearch()">Back to Home</a> &nbsp; &gt; &nbsp;
    <span>{{ searchQueryGrid }}</span>
  </nav>

  <!-- Header Section -->
  <header class="header" style="width: 100%">
    <h1>
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 10px;
          width: 150px;
        "
      >
        <ng-container *ngIf="accountType === 'premium'">
          <img
            src="../../../assets/img/premium.png"
            alt="user type"
            height="40"
          />
        </ng-container>
        <ng-container *ngIf="accountType === 'free'">
          <img
            src="../../../assets/img/evaluation-version.png"
            alt="user type"
            height="40"
          />
        </ng-container>
      </div>
      <img
        src="../../../assets/img/AgropatLogo3.png"
        alt=""
        style="width: 250px"
      />
    </h1>
    <p class="subtitle">
      PROVIDING SOLUTIONS IN CROP PROTECTION FIELD INCLUDING PESTICIDE,
      BIO-PESTICIDE, FERTILIZERS & GROWTH STIMULANTS.
    </p>
    <p class="result-count">
      Total Records: {{ totalRecords }}
      <button
        class="raise-query-btn"
        style="margin-right: 30px"
        (click)="showRaiseQuery()"
      >
        Raise Query
      </button>
    </p>
  </header>

  <div
    class="modal fade bg_4"
    id="raise_query_modal"
    tabindex="-1"
    aria-labelledby="sign_in"
    aria-hidden="true"
  >
    <div class="modal-dialog text-center modal-dialog-centered">
      <div class="modal-content p-x-15 bg_1">
        <div class="dis-block-2">
          <div class="p-top-32">
            <span class="text_blue_9">Raise Query</span>
          </div>
        </div>
        <div class="modal-body">
          <form [formGroup]="form_RaiseQuery" (submit)="submitRaiseQueryForm()">
            <div class="mb-3">
              <label for="user_email" class="form-label dis-flex-4 text_grey_2"
                >Response Email</label
              >
              <input
                type="text"
                class="form-control text_grey_3"
                id="user_email"
                formControlName="txtResponseEmail"
                placeholder="Enter Email ID / User ID"
                required
              />
            </div>
            <div class="mb-3">
              <label for="password" class="form-label dis-flex-4 text_grey_2"
                >Comments</label
              >
              <textarea
                class="form-control"
                id="exampleFormControlTextarea1"
                rows="3"
                formControlName="txtQuery"
                placeholder="Enter Your Comments"
              ></textarea>
            </div>
            <div class="input-group mb-3">
              <input
                type="file"
                #fileInput
                class="form-control"
                id="inputGroupFile01"
                (change)="onFileSelected($event)"
              />
            </div>
            <div class="mb-3 text_start color_black font_14">
              <span class="weight_700">Your Search Query:</span>
              <p class="weight_500">{{ searchQueryGrid }}</p>
            </div>
            <div class="dis_flex jc_end mb-3">
              <button type="submit" class="button_blue_6 text_white_1 p-3 mx-2">
                Submit
              </button>
            </div>
          </form>
          <div class="color_black font_14 weight_500 text_start mb-3">
            ChemRobotics Team is happy to serve you! Your query will be answered
            soon.
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    *ngIf="data && data.length > 0; else noResultsFound"
    class="container-box w-[95%] min-w-[800px] min-h-[600px] bg-white pt-[25px] flex-wrap items-start mx-auto mb-[30px] shadow-[0_4px_8px_#00851d1a,_0_2px_4px_#0783001a] rounded-[10px] transition-transform transition-shadow hover:transform-[translateY(-5px)] hover:shadow-[0_8px_16px_#00861d1a,_0_4px_8px_#0783001a] px-[80px] ng-star-inserted"
  >
    <div *ngFor="let item of data; let i = index" appReadMore>
      <div *ngIf="i % 1 === 0" class="route-label-container">
        <div class="line"></div>
        <div class="route-label">
          ACTIVE INGREDIENT {{ (currPage - 1) * this.currRow + i + 1 }}
        </div>
        <div class="line"></div>
      </div>
      <div class="result-header">
        <h4>
          {{ item.activeIngredient || "-"
          }}<button
            class="copy-btn"
            *ngIf="item.activeIngredient"
            (click)="copyToClipboard(item.activeIngredient)"
            pTooltip="Copy to clipboard"
            tooltipPosition="top"
          >
            <i class="pi pi-copy"></i>
          </button>
        </h4>
      </div>

      <div class="result-content flex w-full">
        <!-- Left Panel -->
        <div class="left-panel">
          <div
            class="chemical-structure"
            *ngIf="displayMap['chemicalStructure'] && item.chemicalStructure"
          >
            <img
              style="width: 350px; height: 250px; object-fit: contain"
              *ngIf="item.chemicalStructure"
              [src]="
                'https://www.chemrobotics.com/agropat/images/chemical_structure/' +
                item.chemicalStructure
              "
              alt="Chemical Structure"
              class="inventor-logo"
            />
            <button
              class="view-btn"
              *ngIf="item.chemicalStructure"
              (click)="ImageFullView(item)"
            >
              View
            </button>
          </div>

          <!-- Bootstrap Modal for Full Image View -->
          <div
            class="modal fade"
            id="imageModal"
            tabindex="-1"
            aria-labelledby="imageModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="imageModalLabel">
                    Chemical Structure
                  </h5>
                  <button
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div class="modal-body text-center">
                  <!-- Ensures content inside is centered -->
                  <img
                    *ngIf="fullImageUrl"
                    [src]="fullImageUrl"
                    alt="Chemical Structure"
                    class="img-fluid w-100"
                  />
                </div>
              </div>
            </div>
          </div>

          <img
            style="width: 100px"
            *ngIf="displayMap['inventorLogo'] && item.inventorLogo"
            [src]="
              'https://www.chemrobotics.com/agropat/images/innovators_logo/' +
              item.inventorLogo
            "
            class="inventor-logo"
            (error)="onImageError($event)"
          />
          <div class="result-header">
            <h6 style="margin-top: 8px">
              {{ item.innovatorOriginator || "-" }}
            </h6>
          </div>
          <button
            class="view-patent-btn"
            (click)="navigateToWebsite('wipo', i)"
          >
            CLICK ME - FOR UPDATED PATENT AT PATENT SCOPE (WIPO)
          </button>
          <p class="note">
            USER CAN REFINE THE PATENT DATA WITH ADDITION OF “SEARCH TERM” IN
            SCRIPT (EXAMPLE): ALL: (PHARMACEUTICAL) AND AP: (PFIZER) AND ALL:
            (POLYMORPH) AND ALL: (PARTICLE) AND ALL: (PROCESS)
          </p>
        </div>

        <!-- Right Panel -->
        <div class="right-panel">
          <!-- Row 1 -->
          <div class="detail-row flex flex-col py-[5px] mb-[20px] w-[30%]">
            <span class="label" *ngIf="displayMap['gbrn'] && item.gbrn"
              >GBRN Number
              <button
                class="copy-btn"
                *ngIf="item.gbrn"
                (click)="copyToClipboard(item.gbrn)"
                pTooltip="Copy to clipboard"
                tooltipPosition="top"
              >
                <i class="pi pi-copy"></i>
              </button>
            </span>
            <span class="value" *ngIf="displayMap['gbrn'] && item.gbrn"
              >{{ item.gbrn || "-" }}
            </span>
            <span
              class="label"
              *ngIf="displayMap['productType'] && item.productType"
              >Product Type
              <button
                class="copy-btn"
                *ngIf="item.productType"
                (click)="copyToClipboard(item.productType)"
                pTooltip="Copy to clipboard"
                tooltipPosition="top"
              >
                <i class="pi pi-copy"></i>
              </button>
            </span>
            <span
              class="value"
              *ngIf="displayMap['productType'] && item.productType"
              >{{ item.productType || "-" }}</span
            >
            <span class="label" *ngIf="displayMap['notes'] && item.notes"
              >Innovator
              <button
                class="copy-btn"
                *ngIf="item.notes"
                (click)="copyToClipboard(item.notes)"
                pTooltip="Copy to clipboard"
                tooltipPosition="top"
              >
                <i class="pi pi-copy"></i></button
            ></span>
            <span class="value" *ngIf="displayMap['notes'] && item.notes"
              >{{ item.notes || "-" }}
            </span>

            <span
              class="label"
              *ngIf="
                displayMap['innovatorOriginator'] && item.innovatorOriginator
              "
              >Developer
              <button
                class="copy-btn"
                *ngIf="item.innovatorOriginator"
                (click)="copyToClipboard(item.innovatorOriginator)"
                pTooltip="Copy to clipboard"
                tooltipPosition="top"
              >
                <i class="pi pi-copy"></i></button
            ></span>
            <span
              class="value"
              *ngIf="
                displayMap['innovatorOriginator'] && item.innovatorOriginator
              "
              >{{ item.innovatorOriginator || "-" }}</span
            >
            <span class="label" *ngIf="item.genericConstrainingDate"
              >GENERIC CONSTRAINING DATE (GCD)
              <button
                class="copy-btn"
                *ngIf="item.genericConstrainingDate"
                (click)="
                  copyToClipboardFormattedDate(item.genericConstrainingDate)
                "
                pTooltip="Copy to clipboard"
                tooltipPosition="top"
              >
                <i class="pi pi-copy"></i></button
            ></span>
            <span
              class="value"
              *ngIf="
                displayMap['genericConstrainingDate'] &&
                item.genericConstrainingDate
              "
            >
              {{
                item.genericConstrainingDate
                  ? (item.genericConstrainingDate | date : "yyyy-MM-dd")
                  : "-"
              }}
            </span>
            <span
              class="label"
              *ngIf="
                displayMap['genericPropDevCadateWdrw'] &&
                item.genericPropDevCadateWdrw
              "
              >GENERIC / PROPRIETARY / DEVELOPING CANDIDATE / WITHDRAWN
              <button
                class="copy-btn"
                *ngIf="item.genericPropDevCadateWdrw"
                (click)="copyToClipboard(item.genericPropDevCadateWdrw)"
                pTooltip="Copy to clipboard"
                tooltipPosition="top"
              >
                <i class="pi pi-copy"></i></button
            ></span>
            <span
              class="value"
              *ngIf="
                displayMap['genericPropDevCadateWdrw'] &&
                item.genericPropDevCadateWdrw
              "
              >{{ item.genericPropDevCadateWdrw || "-" }}</span
            >
          </div>

          <!-- Row 2 -->
          <div class="detail-row">
            <span
              class="label"
              *ngIf="
                displayMap['tradeNameProprietaryName'] &&
                item.tradeNameProprietaryName
              "
              >TRADE NAMES / PROPRIETARY NAME:
              <button
                class="copy-btn"
                *ngIf="item.tradeNameProprietaryName"
                (click)="copyToClipboard(item.tradeNameProprietaryName)"
                pTooltip="Copy to clipboard"
                tooltipPosition="top"
              >
                <i class="pi pi-copy"></i></button
            ></span>
            <span
              class="value"
              *ngIf="
                displayMap['tradeNameProprietaryName'] &&
                item.tradeNameProprietaryName
              "
              [innerHTML]="
                transformNewLines(item.tradeNameProprietaryName || '-')
              "
            ></span>
            <span
              class="label"
              *ngIf="
                displayMap['nameOfGenericChemClass'] &&
                item.nameOfGenericChemClass
              "
              >Name OF Generic Chemistry:
              <button
                class="copy-btn"
                *ngIf="item.nameOfGenericChemClass"
                (click)="copyToClipboard(item.nameOfGenericChemClass)"
                pTooltip="Copy to clipboard"
                tooltipPosition="top"
              >
                <i class="pi pi-copy"></i></button
            ></span>
            <span
              class="value"
              *ngIf="
                displayMap['nameOfGenericChemClass'] &&
                item.nameOfGenericChemClass
              "
              >{{ item.nameOfGenericChemClass || "-" }}</span
            >
            <span class="label" *ngIf="displayMap['iupac'] && item.iupac"
              >iupac
              <button
                class="copy-btn"
                *ngIf="item.iupac"
                (click)="copyToClipboard(item.iupac)"
                pTooltip="Copy to clipboard"
                tooltipPosition="top"
              >
                <i class="pi pi-copy"></i>
              </button>
            </span>
            <span class="value" *ngIf="displayMap['iupac'] && item.iupac">{{
              item.iupac || "-"
            }}</span>
            <span
              class="label"
              *ngIf="
                displayMap['resistanceActionCommitteeRacFracHracIrac'] &&
                item.resistanceActionCommitteeRacFracHracIrac
              "
              >Resistance Action Committee (RAC) / Classes:
              <button
                class="copy-btn"
                *ngIf="item.resistanceActionCommitteeRacFracHracIrac"
                (click)="
                  copyToClipboard(item.resistanceActionCommitteeRacFracHracIrac)
                "
                pTooltip="Copy to clipboard"
                tooltipPosition="top"
              >
                <i class="pi pi-copy"></i></button
            ></span>
            <span
              class="value"
              *ngIf="
                displayMap['resistanceActionCommitteeRacFracHracIrac'] &&
                item.resistanceActionCommitteeRacFracHracIrac
              "
              >{{ item.resistanceActionCommitteeRacFracHracIrac || "-" }}</span
            >
            <span
              class="label"
              *ngIf="
                displayMap['mechanismOfActionMoa'] && item.mechanismOfActionMoa
              "
              >Mechanism of Action (MOA):
              <button
                class="copy-btn"
                *ngIf="item.mechanismOfActionMoa"
                (click)="copyToClipboard(item.mechanismOfActionMoa)"
                pTooltip="Copy to clipboard"
                tooltipPosition="top"
              >
                <i class="pi pi-copy"></i></button
            ></span>
            <span
              class="value"
              *ngIf="
                displayMap['mechanismOfActionMoa'] && item.mechanismOfActionMoa
              "
              [innerHTML]="transformNewLines(item.mechanismOfActionMoa || '-')"
            ></span>
          </div>

          <!-- Row 3 -->
          <div class="detail-row">
            <span
              class="label"
              *ngIf="displayMap['yearOfDiscovery'] && item.yearOfDiscovery"
              >Year of Discovery
              <button
                class="copy-btn"
                *ngIf="item.yearOfDiscovery"
                (click)="copyToClipboard(item.yearOfDiscovery)"
                pTooltip="Copy to clipboard"
                tooltipPosition="top"
              >
                <i class="pi pi-copy"></i></button
            ></span>
            <span
              class="value"
              *ngIf="displayMap['yearOfDiscovery'] && item.yearOfDiscovery"
              >{{ item.yearOfDiscovery || "-" }}</span
            >
            <span
              class="label"
              *ngIf="displayMap['launchingYear'] && item.launchingYear"
              >Launching Year:
              <button
                class="copy-btn"
                *ngIf="item.launchingYear"
                (click)="copyToClipboard(item.launchingYear)"
                pTooltip="Copy to clipboard"
                tooltipPosition="top"
              >
                <i class="pi pi-copy"></i></button
            ></span>
            <span
              class="value"
              *ngIf="displayMap['launchingYear'] && item.launchingYear"
              >{{ item.launchingYear || "-" }}</span
            >

            <span
              class="label"
              *ngIf="
                displayMap['yearWiseOffPatentMolecules'] &&
                item.yearWiseOffPatentMolecules
              "
              >Year Wise off patent molecule:
              <button
                class="copy-btn"
                *ngIf="item.yearWiseOffPatentMolecules"
                (click)="copyToClipboard(item.yearWiseOffPatentMolecules)"
                pTooltip="Copy to clipboard"
                tooltipPosition="top"
              >
                <i class="pi pi-copy"></i></button
            ></span>
            <span
              class="value"
              *ngIf="
                displayMap['yearWiseOffPatentMolecules'] &&
                item.yearWiseOffPatentMolecules
              "
              >{{ item.yearWiseOffPatentMolecules || "-" }}</span
            >
            <span class="label" *ngIf="displayMap['casRn'] && item.casRn"
              >CAS-RN
              <button
                class="copy-btn"
                *ngIf="item.casRn"
                (click)="copyToClipboard(item.casRn)"
                pTooltip="Copy to clipboard"
                tooltipPosition="top"
              >
                <i class="pi pi-copy"></i>
              </button>
            </span>
            <div class="copy-container">
              <span class="value" *ngIf="displayMap['casRn'] && item.casRn">{{
                item.casRn || "-"
              }}</span>
            </div>
            <span
              class="label"
              *ngIf="displayMap['chemicalClass'] && item.chemicalClass"
              >CHEMICAL CLASS:
              <button
                class="copy-btn"
                *ngIf="item.indication"
                (click)="copyToClipboard(item.chemicalClass)"
                pTooltip="Copy to clipboard"
                tooltipPosition="top"
              >
                <i class="pi pi-copy"></i>
              </button>
            </span>
            <span
              class="value"
              *ngIf="displayMap['chemicalClass'] && item.chemicalClass"
              >{{ item.chemicalClass || "-" }}
            </span>
            <span
              class="label"
              *ngIf="displayMap['indication'] && item.indication"
              >indication
              <button
                class="copy-btn"
                *ngIf="item.indication"
                (click)="copyToClipboard(item.indication)"
                pTooltip="Copy to clipboard"
                tooltipPosition="top"
              >
                <i class="pi pi-copy"></i>
              </button>
            </span>
            <span
              class="value"
              *ngIf="displayMap['indication'] && item.indication"
              >{{ item.indication || "-" }}
            </span>

            <span
              class="label"
              *ngIf="displayMap['COMMENTRY'] && item?.COMMENTRY"
              >ISO-Publication
              <button
                class="copy-btn"
                *ngIf="item.isoStatus"
                (click)="copyToClipboard(item.isoStatus)"
                pTooltip="Copy to clipboard"
                tooltipPosition="top"
              >
                <i class="pi pi-copy"></i>
              </button>
            </span>
            <span
              class="value"
              *ngIf="displayMap['COMMENTRY'] && item?.COMMENTRY"
              >{{ item?.COMMENTRY || "-" }}
            </span>
            <span
              class="label"
              *ngIf="displayMap['isoStatus'] && item.isoStatus"
              >ISO STATUS:
              <button
                class="copy-btn"
                *ngIf="item.isoStatus"
                (click)="copyToClipboard(item.isoStatus)"
                pTooltip="Copy to clipboard"
                tooltipPosition="top"
              >
                <i class="pi pi-copy"></i>
              </button>
            </span>
            <span
              class="value"
              *ngIf="displayMap['isoStatus'] && item.isoStatus"
              >{{ item.isoStatus || "-" }}
            </span>
            <div class="copy-container">
              <span
                class="label"
                *ngIf="displayMap['pubchemId'] && item.pubchemId"
                style="display: block !important; font-weight: bold"
              >
                PUBCHEM CID:
                <button
                  class="copy-btn"
                  *ngIf="item.pubchemId"
                  (click)="copyToClipboard(item.pubchemId)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </span>

              <a
                target="_blank"
                style="
                  padding: 10px;
                  background: #006400;
                  text-decoration: none;
                  border-radius: 5px;
                  cursor: pointer;
                  display: inline-block;
                "
                [href]="
                  'https://pubchem.ncbi.nlm.nih.gov/compound/' + item.pubchemId
                "
              >
                <span
                  class="value"
                  *ngIf="displayMap['pubchemId'] && item.pubchemId"
                  style="color: rgb(255 237 141)"
                >
                  {{ item.pubchemId || "-" }}
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-links">
        <!-- Button 1 -->
        <button
          class="footer-btn"
          style="
            background: linear-gradient(145.5deg, #388e3c, #235e5e 99.58%);
            color: rgb(255 237 141);
          "
          (click)="
            largescreen(
              item.gbrn,
              '/platform/product-information',
              item.activeIngredient
            )
          "
        >
          DETAILED PRODUCT LANDSCAPE
        </button>
        <!-- <button
          class="footer-btn"
          style="
            background: linear-gradient(145.5deg, #388e3c, #235e5e 99.58%);
            color: rgb(255 237 141);
          "
          (click)="showToast()"
        >
          ACTIVE INGREDIENT PROCESS
        </button> -->

        <!-- Button 2 -->
        <button
          class="footer-btn"
          (click)="
            largescreen(
              item.gbrn,
              '/platform/technical-route',
              item.activeIngredient
            )
          "
        >
          MANUFACTURING SYNTHESIS
        </button>

        <!-- Button 3 -->
        <button
          class="footer-btn"
          (click)="
            largescreen(
              item.gbrn,
              '/platform/important-patent-database',
              item.activeIngredient
            )
          "
          style="
            background: linear-gradient(145.5deg, #388e3c, #235e5e 99.58%);
            color: rgb(255 237 141);
          "
        >
          IMPORTANT PATENTS
        </button>

        <!-- Button 4 -->
        <button
          class="footer-btn"
          (click)="
            largescreen(
              item.gbrn,
              '/platform/gapd-database',
              item.activeIngredient
            )
          "
        >
          GLOBAL PESTICIDE APPROVAL
        </button>

        <!-- Button 5 -->
        <button
          class="footer-btn"
          (click)="
            largescreen(
              item.gbrn,
              '/platform/ipd-database',
              item.activeIngredient
            )
          "
          style="
            background: linear-gradient(145.5deg, #388e3c, #235e5e 99.58%);
            color: rgb(255 237 141);
          "
        >
          INDIAN PESTICIDE APPROVAL
        </button>

        <!-- Button 6 -->
        <button
          class="footer-btn"
          (click)="
            largescreen(
              item.gbrn,
              '/platform/impurity-database',
              item.activeIngredient
            )
          "
        >
          IMPURITY
        </button>

        <!-- Button 7 -->
        <button
          class="footer-btn"
          (click)="
            largescreen(
              item.gbrn,
              '/platform/cipac-database',
              item.activeIngredient
            )
          "
          style="
            background: linear-gradient(145.5deg, #388e3c, #235e5e 99.58%);
            color: rgb(255 237 141);
          "
        >
          ANALYTICAL METHODS (CIPAC)
        </button>

        <!-- Button 8 -->
        <button
          class="footer-btn"
          (click)="
            largescreen(
              item.gbrn,
              '/platform/mrl-database',
              item.activeIngredient
            )
          "
        >
          MRL
        </button>

        <!-- Button 9 -->
        <button
          class="footer-btn"
          (click)="
            largescreen(
              item.gbrn,
              '/platform/quik-patent-database',
              item.activeIngredient
            )
          "
          style="
            background: linear-gradient(145.5deg, #388e3c, #235e5e 99.58%);
            color: rgb(255 237 141);
          "
        >
          QUICK PATENT
        </button>

        <!-- Button 10 -->
        <button
          class="footer-btn"
          (click)="
            largescreen(
              item.gbrn,
              '/platform/non-patent-database',
              item.activeIngredient
            )
          "
        >
          NON - PATENT
        </button>
        <button
          class="footer-btn"
          style="
            background: linear-gradient(145.5deg, #388e3c, #235e5e 99.58%);
            color: rgb(255 237 141);
          "
          (click)="
            largescreen(
              item.gbrn,
              '/platform/spc-database',
              item.activeIngredient
            )
          "
        >
          SPC
        </button>
        <button
          class="footer-btn"
          (click)="
            largescreen(
              item.gbrn,
              '/platform/litigation-database',
              item.activeIngredient
            )
          "
        >
          PATENT LITIGATION
        </button>
        <button
          class="footer-btn"
          style="
            background: linear-gradient(145.5deg, #388e3c, #235e5e 99.58%);
            color: rgb(255 237 141);
          "
          (click)="
            largescreen(
              item.gbrn,
              '/platform/scientific-docs-database',
              item.activeIngredient
            )
          "
        >
          SCIENTIFIC DOCS
        </button>
      </div>
      <button class="back_to_top my-5" (click)="scrollToTop()">
        <img
          class="back_to_top_img"
          src="../../../assets/icons/output-onlinepngtools (5).png"
        />
      </button>
    </div>

    <div class="pagination-container">
      <p-paginator
        *ngIf="totalRecords > 15"
        (onPageChange)="onPageChange($event)"
        [first]="first"
        [rows]="rows"
        [totalRecords]="totalRecords"
        [styleClass]="'custom-paginator'"
      >
      </p-paginator>
      <p class="total-pages" *ngIf="totalpages > 2">
        Total Pages: <span>{{ totalpages }}</span>
      </p>
    </div>
  </div>

  <ng-template #noResultsFound>
    <div class="no-results-container">
      <img
        src="../../../assets/img/no-data.png"
        class="no-results-image"
        alt="No data available"
      />
      <div class="no-results-message color_black">
        <span class="font_20 weight_800"
          >Sorry – The search found zero results. Why…</span
        >
        <ul class="no-results-list text_start">
          <li>
            <span class="font_20 weight_500"
              >Make sure you have selected the correct search criteria</span
            >
          </li>
          <li>
            <span class="font_20 weight_500"
              >Make sure that all words are spelled correctly</span
            >
          </li>
          <li>
            <span class="font_20 weight_500">Try different keywords</span>
          </li>
          <li>
            <span class="font_20 weight_500">Try more general keywords</span>
          </li>
        </ul>
      </div>
      <!-- Back to search button -->
      <button class="btn-back-to-search" (click)="goBackToSearch()">
        Back to Search
      </button>
    </div>
  </ng-template>
  <!-- <p-galleria
    [value]="images"
    [(visible)]="displayBasic"
    [responsiveOptions]="responsiveOptions"
    [containerStyle]="{ 'max-width': '850px' }"
    [numVisible]="7"
    [circular]="true"
    [fullScreen]="true"
    [showItemNavigators]="false"
    [showThumbnails]="false"
    style="background-color: rgba(0, 0, 0, 0.9); z-index: 1000"
  >
    <ng-template pTemplate="item" let-item>
      <img [src]="item.itemImageSrc" style="width: 100%" />
    </ng-template>
  </p-galleria> -->
  </div>
</div>
<app-footer></app-footer>
